<template>
  <b-modal :active="value" has-modal-card @close="close()">
    <form v-if="value" action="">
      <div class="modal-card" style="width: 800px">
        <!-- ヘッダ -->
        <header class="modal-card-head">
          <p
            class="modal-card-title"
            style="color: whitesmoke; text-align: left"
          >
            カテゴリ管理
          </p>
        </header>

        <!-- セクション -->
        <section class="modal-card-body" style="width: 100%; text-align: left">
          <div class="columns">
            <div class="column is-four-fifths">
              <b-field 
                label="カテゴリ名"
                labelPosition="on-border"
                :type="{ 'is-danger': errors.has('categoryName') }"
                :message="errors.first('categoryName')">
                <b-input
                  v-model="categoryName"
                  name="categoryName"
                  type="text"
                  data-vv-as="カテゴリ名"
                  v-validate="'required'"
                  maxlength="50"
                ></b-input>
              </b-field>
            </div>

            <div class="column">
              <b-button
                class="button is-primary has-text-centered"
                native-type="button"
                @click="add()"
              >
                追加
              </b-button>
            </div>
          </div>

          <div class="columns">
            <div class="column">
              <b-field
                horizontal
                label="カテゴリ数"
                style="float: right; white-space: nowrap"
              >
                <b-select position="is-right" v-model="perPage">
                  <option value="10">10</option>
                  <option value="20">20</option>
                  <option value="50">50</option>
                </b-select>
              </b-field>
            </div>
          </div>

          <div class="columns">
            <div class="column if-full">
              <b-table
                :data="data"
                :paginated="isPaginated"
                :per-page="perPage"
                :current-page.sync="currentPage"
                :pagination-simple="isPaginationSimple"
                :pagination-position="paginationPosition"
                :pagination-size="paginationSize"
                :default-sort-direction="defaultSortDirection"
                default-sort="id"
                aria-next-label="Next page"
                aria-previous-label="Previous page"
                aria-page-label="Page"
                aria-current-label="Current page"
              >
                <template slot-scope="props">
                  <b-table-column
                    field="id"
                    label="No"
                    sortable
                    centered
                    >{{ props.row.id }}</b-table-column
                  >

                  <b-table-column
                    field="categoryName"
                    label="カテゴリ名"
                    sortable
                  >
                    <b-field 
                      labelPosition="on-border" 
                      :type="{ 'is-danger': errors.has('categoryName' + props.index) }"
                      :message="errors.first('categoryName' + props.index)">
                      <b-input
                        v-model="props.row.categoryName"
                        :name="'categoryName' + props.index"
                        type="text"
                        data-vv-as="カテゴリ名" 
                        v-validate="'required'"
                        maxlength="50"
                      ></b-input>
                    </b-field>
                  </b-table-column>

                  <b-table-column label="保存" centered>
                    <b-button
                      class="button is-primary has-text-centered"
                      icon-left="mdi mdi-content-save"
                      native-type="button"
                      @click="save(props.row, props.index)"
                    ></b-button>
                  </b-table-column>
                </template>
              </b-table>
            </div>
          </div>
        </section>

        <!-- フッタ -->
        <footer class="modal-card-foot">
          <b-button class="button" type="button" @click="close()"
            >閉じる</b-button
          >
        </footer>
      </div>
    </form>
  </b-modal>
</template>

<script>
export default {
  name: "AppSupportCategory",
  props: {
    value: { type: Boolean, default: false },
  },

  methods: {
    close: function () {
      this.$emit("input", false);
      return;
    },

    // 追加
    add: async function () {
      const validateRes = await this.$validator.validate("categoryName");
      if(!validateRes) {
        return;
      }

      // WebAPI呼び出し
      this.apiCall(this.setPatientSupportHistoryCategoryPOST, this.setPatientSupportHistoryCategoryPOSTsucces, this.setPatientSupportHistoryCategoryPOSTerror);
      return;
      },

    // 保存
    save: async function (category, index) {
      this.saveCategory = category;
      const validateRes = await this.$validator.validate("categoryName" + index);
      if(!validateRes) {
        return;
      }

      // WebAPI呼び出し
      this.apiCall(this.setPatientSupportHistoryCategoryPUT, this.setPatientSupportHistoryCategoryPUTsucces, this.setPatientSupportHistoryCategoryPUTerror);
      return;
    },

    initData: function () {
      this.categoryName = null;

      // WebAPI呼び出し
      this.apiCall(this.getPatientSupportHistoryCategoriesGET, this.getPatientSupportHistoryCategoriesGETsucces, this.getPatientSupportHistoryCategoriesGETerror);
      return;
    },

    // カテゴリ一覧取得WebAPI実行
    getPatientSupportHistoryCategoriesGET: function (client) {
      const apiRes = client.apis.apiPatientSupport.getPatientSupportHistoryCategoriesGET()
      return apiRes;
    },
    getPatientSupportHistoryCategoriesGETsucces: function (result) {
      this.data = result.obj;
      return;
    },
    getPatientSupportHistoryCategoriesGETerror: function (result) {
      this.showErrorMessage(result);
      return;
    },

    // 追加WebAPI実行
    setPatientSupportHistoryCategoryPOST: function (client) {
      const apiRes = client.apis.apiPatientSupport.setPatientSupportHistoryCategoryPOST({
        body: {
          categoryName: this.categoryName,
        }
      })
      return apiRes;
    },
    setPatientSupportHistoryCategoryPOSTsucces: function (result) {
      this.showSuccess(result);
      this.initData();
      return;
    },
    setPatientSupportHistoryCategoryPOSTerror: function (result) {
      this.showErrorMessage(result);
      return;
    },

    // 保存WebAPI実行
    setPatientSupportHistoryCategoryPUT :function (client) {
      const apiRes = client.apis.apiPatientSupport.setPatientSupportHistoryCategoryPUT ({
        body: this.saveCategory,
      })
      return apiRes;
    },
    setPatientSupportHistoryCategoryPUTsucces :function (result) {
      this.showSuccess(result);
      return;
    },
    setPatientSupportHistoryCategoryPUTerror :function (result) {
      this.showErrorMessage(result);
      return;
    },
  },

  mounted: function () {
    return;
  },

  data() {
    return {
      categoryName: null,
      data: [],
      isPaginated: true,
      isPaginationSimple: false,
      paginationPosition: "top",
      paginationSize: "is-small",
      defaultSortDirection: "asc",
      currentPage: 1,
      perPage: 10,
      saveCategory: null,
    };
  },

  watch: {
    value: function () {
      if (this.value) {
        this.initData();
      }
      return;
    },
  },

  filters: {},

  components: {},
};
</script>



// WEBPACK FOOTER //
// src/components/AppSupportCategory.vue